<template>
  <el-dialog :visible.sync="visible" @open="init" class="layout-video-dialog" width="800px" :canResize="false" :before-close="beforeClose">
    <div class="layout-video-dialog-body">
      <div class="close-btn" @click="close">
        <i class="el-icon-close"></i>
      </div>
      <video webkit-playsinline="true" playsinline="true" width="100%" id="tc-player"></video>
      <div class="btn-box" v-if="dialogData && dialogData.skipType !== 0" @click="handleClick">
        {{getJumpText}} <i class="el-icon-arrow-right" />
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import { handleJumpTo } from './utils'

  export default {
    components: { },
    data() {
      return {
        isCanplay: false,
        visible: false,
        dialogData: {}
      }
    },
    computed: {
      getJumpText () {
        const {menuCode, appName} = this.dialogData || {}
        if (menuCode && appName) return `前往${appName}模块`
        return '点击查看详情'
      }
    },
    methods: {
      init () {
        this.$nextTick(() => {
          this.initPlayer()
        })
        this.$emit('updateRead', this.dialogData)
        // updateRead(this.dialogData)
      },
      initPlayer () {
        if (!this.player) {
          // 视频播放器
          import(/* webpackChunkName: "public-tcplayer-erpnoparse" */ '../erpnoparse/tcplayer.min.css')
          import(/* webpackChunkName: "public-tcplayer-erpnoparse" */ '../erpnoparse/tcplayer.v5.0.0.min.js').then(module => {
            const TCPlayer = module
            console.log(TCPlayer, module)
            this.player = TCPlayer('tc-player', {
              licenseUrl: 'https://license.vod2.myqcloud.com/license/v2/1256892229_1/v_cube.license',
              autoplay: false,
              poster: '', // 封面
              posterImage: true,
              preload: 'auto',
              controlBar: { // 设置控制栏属性的参数组合
                volumePanel: true,
                playbackRateMenuButton: true,
                fullscreenToggle: true
              },
              plugins: { // 设置插件功能属性的参数组合
                ContinuePlay: {
                  auto: true
                }
              }
            })
            this.player.poster(this.dialogData.iconUrlV2)
            this.player.src(this.dialogData.videoUrl)
            this.player.currentTime(0)
          })
        } else {
          this.player.poster(this.dialogData.iconUrlV2)
          this.player.src(this.dialogData.videoUrl)
          this.player.currentTime(0)
        }
      },
      handleClick () {
        const data = this.dialogData
        if ([1, 3].includes(data && data.skipType)) {
          this.$emit('updateFeedback', data)
        }
        handleJumpTo(data)
        this.visible = false
      },
      open (val) {
        this.dialogData = val
        this.visible = true
      },
      close () {
        this.player && this.player.pause()
        this.dialogData = null
        this.visible = false
      },
      beforeClose (done) {
        this.player && this.player.pause()
        done()
      }
    }
  }
</script>

<style lang="scss" scoped>
// @import '../erpnoparse/tcplayer.min.css';
.layout-video-dialog {
  #tc-player {
    width: 100%;
    height: 100%;
  }
  /deep/ .el-dialog {
    &__header {
      display: none;
    }
    &__body {
      padding: 0px;
      height: 450px;
      width: 800px;
      max-height: 450px;
    }
    .prism-setting-cc {
      display: none;
    }
    .prism-setting-audio {
      display: none;
    }
    .prism-setting-quality {
      display: none;
    }
    .prism-setting-list {
      display: block !important;
      width: 58px;
      right: 58px;
      bottom: 6px;
      background: transparent;
    }
    .prism-setting-btn {
      display: none;
    }
    .prism-setting-speed {
      .array {
        display: none;
      }
      .current-setting {
        display: none;
      }
    }
    .prism-setting-selector {
      width: 80px;
      border-radius: 4px;
      .header {
        display: none;
      }
      .selector-list {
        overflow: hidden;
        background: rgba(0, 0, 0, 0.8);
        border-radius: 4px;
        margin-top: 0px;
      }
    }
    video {
      background: #03050D;
    }
  }
  &-body {
    position: relative;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
  .close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 30px;
    height: 30px;
    line-height: 30px;
    font-size: 20px;
    text-align: center;
    cursor: pointer;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.4);
    color: #ffffff;
    z-index: 1000;
  }
  .btn-box {
    position: absolute;
    // width: 146px;
    width: fit-content;
    padding: 0 12px;
    height: 32px;
    border-radius: 4px;
    background: rgba(0, 0, 0, 0.2);
    color: #ffffff;
    display: flex;
    align-items: center;
    cursor: pointer;
    right: 12px;
    bottom: 66px;
    &:hover {
      font-weight: 600;
    }
    .btn-left {
      color: var(--g-color-text);
      font-size: 12px;
      height: 15px;
      line-height: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/banner/video-dialog.vue